interface BrushSizeControlProps {
  value: number;
  onChange: (size: number) => void;
}

export function BrushSizeControl({ value, onChange }: BrushSizeControlProps) {
  return (
    <label className="drawing-control" htmlFor="brush-size">
      <span>
        Size <output htmlFor="brush-size">{value} px</output>
      </span>
      <input
        id="brush-size"
        max="64"
        min="1"
        onChange={(event) => onChange(Number(event.target.value))}
        type="range"
        value={value}
      />
    </label>
  );
}
